import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@fluentui/react-components';
import { PlannerLeftNav } from '@/components/planner/PlannerLeftNav';
import { CalendarPanel } from '@/layouts';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    minHeight: '100%',
    boxSizing: 'border-box',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    boxSizing: 'border-box',
  },
});

export const CalendarLayout = () => {
  const styles = useStyles();
  const navigate = useNavigate();

  const handleNavChange = useCallback(
    (key: string) => {
      if (key === 'calendar-view') return;
      void navigate('/planner');
    },
    [navigate]
  );

  return (
    <div className={styles.root}>
      <PlannerLeftNav defaultSelectedKey="calendar-view" onSelectionChange={handleNavChange} />
      <div className={styles.content}>
        <CalendarPanel />
      </div>
    </div>
  );
};

CalendarLayout.displayName = 'CalendarLayout';
